



















import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { EVENT_NAMES } from "@scrile/api-provider/dist";
import emitter from "@/lib/emitter";
import { Notification } from "@/types";
import { EVENTS } from "@/const";
import BaseIcon from "@/components/BaseIcon";

@Component({ name: "StatusNotificationBar", components: { BaseIcon } })
export default class StatusNotificationBar extends Vue {
  public notificationList: Notification[] = [];

  public show = false;

  public addNotification(text: string, type: "error" = "error") {
    const notification: Notification = {
      text,
      type,
    };
    const exist = this.notificationList.findIndex(item => item.text === text) > -1;
    if (exist) return;
    this.notificationList = [...this.notificationList, notification];
    this.show = true;
  }

  public clearNotifications() {
    this.notificationList = [];
  }

  public showNotificationHandler({ text, type }: Notification) {
    this.addNotification(text, type);
  }

  public requestStatusHandler({ status, message }: { status: string; message: string }) {
    if (status === "error") this.addNotification(message, status);
  }

  @Watch("$route")
  public watchRoute(to: Route, from: Route) {
    if (to.path !== from.path) {
      this.clearNotifications();
    }
  }

  public mounted() {
    emitter.on<any>(EVENTS.STATUS_SHOW, this.showNotificationHandler);
    emitter.on<any>(EVENTS.STATUS_HIDE, this.clearNotifications);
    emitter.on<any>(EVENT_NAMES.REQUEST_STATUS, this.requestStatusHandler);
  }
  public beforeDestroy() {
    emitter.off<any>(EVENTS.STATUS_SHOW, this.showNotificationHandler);
    emitter.off<any>(EVENTS.STATUS_HIDE, this.clearNotifications);
    emitter.off<any>(EVENT_NAMES.REQUEST_STATUS, this.requestStatusHandler);
  }
}
